<template>
  <RutasForm />
</template>
<script setup>
import RutasForm from './RutasForm.vue'
</script>